import { Routes } from '@angular/router';
import { LayoutAuthComponent } from '@layout/auth/auth.component';
import { LayoutMainComponent } from '@layout/main/main.component';
import { authGuard } from '@core/guards/auth.guard';
import { certificatesOnlyGuard } from '@core/guards/certificates-only.guard';
import { FIELD_RENDERERS, TABLE_RENDERERS } from '@shared/components/app-renderers';
// Renderers de cada módulo
import { creditFieldRenderers, creditTableRenderers } from '@custom-components/credits/credit-renderers';
import {
  affiliationFieldRenderers,
  affiliationTableRenderers,
} from '@custom-components/affilliation/affiliation-renderers';

import { formRoutes, standardRoutes } from './route-config';

const layoutMapping = {
  auth: LayoutAuthComponent,
  public: LayoutAuthComponent,
  main: LayoutMainComponent,
};

// Re-export for consumers that import from this file
export { formRoutes, standardRoutes };

export const appFullRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${formRoutes.public.path}/home`,
    // redirectTo: `${formRoutes.home.path}/inicio`,
  },
  {
    path: formRoutes.public.path,
    component: layoutMapping.public,
    loadChildren: () => import('./public-routes').then(m => m.publicRoutes),
  },
  {
    path: formRoutes.auth.path,
    component: layoutMapping.auth,
    loadChildren: () => import('./auth-routes').then(m => m.authRoutes),
  },
  {
    path: formRoutes.cleanForms.path,
    component: layoutMapping.main,
    loadChildren: () => import('./clean-routes').then(m => m.cleanRoutes),
  },
  {
    path: formRoutes.home.path,
    component: layoutMapping.main,
    canActivate: [authGuard],
    loadChildren: () => import('./home-routes').then(m => m.homeRoutes),
  },
  {
    path: formRoutes.dashboard.path,
    component: layoutMapping[formRoutes.dashboard.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    loadChildren: () => import('./dashboard-routes').then(m => m.dashboardRoutes),
  },
  {
    path: formRoutes.citizen.path,
    component: layoutMapping[formRoutes.citizen.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    loadChildren: () => import('./citizen-routes').then(m => m.citizenRoutes),
  },
  {
    path: formRoutes.products.path,
    component: layoutMapping[formRoutes.products.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    loadChildren: () => import('./products-routes').then(m => m.productsRoutes),
  },
  {
    path: formRoutes.notifications.path,
    component: layoutMapping[formRoutes.notifications.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    loadChildren: () => import('./notifications-routes').then(m => m.notificationsRoutes),
  },
  {
    path: formRoutes.credits.path,
    component: layoutMapping[formRoutes.credits.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    providers: [
      { provide: FIELD_RENDERERS, useValue: creditFieldRenderers },
      { provide: TABLE_RENDERERS, useValue: creditTableRenderers },
    ],
    loadChildren: () => import('./credits-routes').then(m => m.creditRoutes),
  },
  {
    path: formRoutes.affiliation.path,
    component: layoutMapping[formRoutes.affiliation.layout],
    canActivate: [authGuard],
    canActivateChild: [certificatesOnlyGuard],
    providers: [
      { provide: FIELD_RENDERERS, useValue: affiliationFieldRenderers },
      { provide: TABLE_RENDERERS, useValue: affiliationTableRenderers },
    ],
    loadChildren: () => import('./affiliation-routes').then(m => m.affiliationRoutes),
  },
];
